import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载


export const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
    messages: {
        ar: require("./lan/ar"),
        cs: require("./lan/cs"),
        de: require("./lan/de"),
        en: require("./lan/en"),
        es: require("./lan/es"),
        fr: require("./lan/fr"),
        he: require("./lan/he"),
        hu: require("./lan/hu"),
        it: require("./lan/it"),
        ja: require("./lan/ja"),
        ko: require("./lan/ko"),
        nl: require("./lan/nl"),
        pt: require("./lan/pt"),
        pt_BR: require("./lan/pt_BR"),
        ru: require("./lan/ru"),
        sv: require("./lan/sv"),
        tr: require("./lan/tr"),
        uk: require("./lan/uk"),
        zh: require("./lan/zh"),
        zh_tw: require("./lan/zh_tw"),


    }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js